<template>
  <div
    class="home"
    style="min-width: 1455px; overflow: auto; position: relative"
  >
    <div class="titleBar">
      <div class="titleName"></div>
      <!-- <div class="titlePhone">
        <i class="el-icon-phone" style="margin-right: 8px"></i
        ><span>总机电话:0315-5907613/5907616</span>
      </div> -->
      <template v-if="hasLogin">
        <div
          class="entryLink"
          @click="toLink"
          style="cursor: pointer"
          v-if="!token"
        ></div>
        <div class="userName" v-else>
          <div v-if="token">
            {{ userInfo.nickName + "，您好！" }}
          </div>
          <div
            v-if="token"
            style="cursor: pointer; margin: 0 25px"
            @click="goManage"
          >
            进入后台管理
          </div>
          <div v-if="token" style="cursor: pointer" @click="logout">退出</div>
        </div>
      </template>
    </div>
    <div class="top">
      <div
        style="
          width: 1180px;
          height: 320px;
          background-color: rgba(255, 255, 255, 0.1);
          display: flex;
          flex-direction: column;
          align-items: center;
        "
      >
        <p
          style="
            font-size: 72px;
            letter-spacing: 10px;
            color: #fff;
            font-weight: 700;
            margin-top: 60px;
          "
        >
          唐山城发集中采购平台
        </p>
        <p
          style="
            font-size: 22px;
            margin-top: 20px;
            color: #fff;
            font-weight: 700;
            padding-right: 10px;
          "
        >
          TANGSHAN URBAN NVSIMENTCBNIRALZED PROCURBMBNT PLATFORM
        </p>

        <div class="joinUs" @click="toRegister" v-if="hasRegister"></div>
      </div>
    </div>
    <div style="margin: 0px 15%">
      <el-menu
        :default-active="activeIndex"
        class="el-menu-demo"
        mode="horizontal"
        active-text-color="#be8737"
        text-color="#666666"
        @select="handleSelect"
      >
        <!-- <el-menu-item index="xunjia">询比信息</el-menu-item> -->
        <el-menu-item index="caigou">采购公告</el-menu-item>
        <el-menu-item index="biangeng">变更公告</el-menu-item>
        <!-- <el-menu-item index="zhongzhi">中止公告</el-menu-item> -->
        <el-menu-item index="zhongbiao">成交公告</el-menu-item>
        <el-menu-item index="feibiao">终止公告</el-menu-item>
        <el-menu-item index="qiye">企业名录</el-menu-item>
      </el-menu>
    </div>
    <div style="padding-top: 10px; min-height: 500px">
      <component :is="currentRole" @rowClick="toDetail" />
    </div>

    <!-- <div
      style="
        width: 100%;
        display: flex;
        justify-content: center;
        margin-top: 20px;
        cursor: pointer;
      "
    >
      <div class="img-link" @click="toLink">
        <el-image :src="img" :fit="'contain'" lazy></el-image>
      </div>
    </div> -->

    <div class="bottom">
      <div class="bottomLogo"></div>
      <p
        style="
          height: 116px;
          line-height: 116px;
          color: #fff;
          font-size: 68px;
          letter-spacing: 15px;
          margin-left: 40px;
        "
      >
        唐山城发集中采购平台
      </p>
    </div>
    <!-- <p
      style="
        position: absolute;
        bottom: 30px;
        text-align: center;
        left: 0;
        right: 0;
        color: #fff;
        font-size: 15px;
      "
    >
      Copyright © 唐山市城市发展集团有限公司 All Rights Reserved
      备案号：冀ICP备2022028956号-1
    </p> -->
    <el-dialog :visible.sync="loginVisible" width="500px">
      <login v-if="loginVisible" @success="loginSuccess"></login>
    </el-dialog>
  </div>
</template>

<script>
import {
  getNoticeList,
  getPurchaseList,
  getSupplierList,
  getRNoticeList,
  getEnquiryList,
  getConfig,
  getLoginSetting,
  getRegisterSetting,
} from "@/api/home";
import caigou from "@/components/caigou.vue";
import biangeng from "@/components/biangeng.vue";
import zhongzhi from "@/components/zhongzhi.vue";
import xunjia from "@/components/xunjia.vue";
import zhongbiao from "@/components/zhongbiao.vue";
import feibiao from "@/components/feibiao.vue";
import qiye from "@/components/qiye.vue";
import { scrollTo } from "@/utils/scroll-to";
import {
  getToken,
  getUserInfo,
  removeToken,
  removeUserInfo,
} from "@/utils/auth";
// import img from "@/assets/link.jpg";
export default {
  name: "HomeView",
  components: {
    caigou,
    biangeng,
    zhongbiao,
    feibiao,
    qiye,
    xunjia,
    zhongzhi,
  },

  data() {
    return {
      // img,
      token: getToken(),
      userInfo: JSON.parse(getUserInfo()) || {
        nickName: "",
      },
      detailId: "",
      loginVisible: false,
      currentRole: "caigou",
      activeIndex: "caigou",
      enquiryList: [],
      purchaseList: [],
      noticeList: [],
      rnoticeList: [],
      supplierList: [],
      enquiry: {
        pageNum: 1,
        pageSize: 10,
      },
      purchaseParams: {
        pageNum: 1,
        pageSize: 10,
      },
      noticeParams: {
        pageNum: 1,
        pageSize: 10,
      },
      rnoticeParams: {
        pageNum: 1,
        pageSize: 10,
      },
      supplierParams: {
        pageNum: 1,
        pageSize: 10,
      },
      hasLogin: false,
      hasRegister: false,
    };
  },
  created() {
    scrollTo(0, 800);
  },
  mounted() {
    getLoginSetting().then((res) => {
      if (res.data == "true") {
        this.hasLogin = true;
      }
    });
    getRegisterSetting().then((res) => {
      if (res.data == "true") {
        this.hasRegister = true;
      }
    });
  },
  methods: {
    goManage() {
      getConfig().then((res) => {
        if (res.msg) {
          window.open(`${res.msg}/login?token=${getToken()}`, "官网");
        }
      });
      // window.open(`http://192.168.1.172:81/login?token=${getToken()}`, "官网");
    },
    loginSuccess() {
      this.loginVisible = false;
      this.token = getToken();
      this.userInfo = JSON.parse(getUserInfo()) || {
        nickName: "",
      };
      setTimeout(() => {
        this.$forceUpdate();
        if (this.detailId) {
          this.toDetail({ id: this.detailId });
        }
      }, 50);
    },
    logout() {
      removeToken();
      removeUserInfo();
      this.token = "";
      this.userInfo = {
        nickName: "",
      };
      setTimeout(() => {
        this.$forceUpdate();
      }, 50);
    },
    toLink() {
      this.loginVisible = true;
      // window.open(`http://eps.tscfjt.com/login`, "官网");
    },
    handleSelect(e) {
      this.currentRole = e;
    },
    getList() {
      getEnquiryList(this.enquiryParams).then((res) => {
        this.enquiryList = res.rows;
      });
    },
    getList1() {
      getPurchaseList(this.purchaseParams).then((res) => {
        this.purchaseList = res.rows;
        this.purchaseList.forEach((item) => {
          item.time = this.countdown(new Date(item.expiryTime).getTime());
        });
      });
    },
    getList2() {
      getNoticeList(this.noticeParams).then((res) => {
        this.noticeList = res.rows;
      });
    },
    getList3() {
      getSupplierList(this.supplierParams).then((res) => {
        this.supplierList = res.rows;
      });
    },
    getList4() {
      getRNoticeList(this.rnoticeParams).then((res) => {
        this.rnoticeList = res.rows;
      });
    },
    toRegister() {
      getConfig().then((res) => {
        if (res.msg) {
          window.open(res.msg + "/supplierRegister", "注册");
        }
      });
      //let url = window.location.href;
      //let arr = url.split(":");
      //window.open(`http://${arr[1]}:32002/supplierRegister`, "注册");
    },
    toDetail(item) {
      if (this.token) {
        window.open("/#/detail?id=" + item.id, "采购公告");
      } else {
        if (this.hasLogin) {
          this.detailId = item.id;
          this.loginVisible = true;
        } else {
          window.open("/#/detail?id=" + item.id, "采购公告");
        }
      }
    },
    toDetails(item) {
      window.open("/#/details?id=" + item.id, "成交公告");
    },
    toRDetails(item) {
      window.open("/#/rdetails?id=" + item.id, "终止公告");
    },
    countdown(targetTime) {
      const now = new Date().getTime();
      const difference = targetTime - now;

      // 如果差值小于或等于0，则显示0天0时0分0秒
      if (difference <= 0) {
        return "0天0小时";
      }

      // 计算差值对应的天、时、分、秒
      let days = Math.floor(difference / (1000 * 60 * 60 * 24));
      let hours = Math.floor(
        (difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
      );

      return `${days}天${hours}小时`;
    },
  },
};
</script>
<style>
.center {
  margin: 0 15%;
}
.el-menu-item {
  height: 100px !important;
  line-height: 100px !important;
  font-size: 26px !important;
}
p {
  margin: 0;
  padding: 0;
}
.bottom {
  height: 298px;
  margin-top: 80px;
  background-image: url("../assets/footer.jpg");
  background-size: cover;
  display: flex;
  justify-content: center;
  padding-top: 60px;
}
.bottomLogo {
  height: 116px;
  width: 116px;
  background-image: url("../assets/footer_10.png");
  background-size: cover;
}
.top {
  height: 492px;
  background-image: url("../assets/banner.jpg");
  background-size: cover;
  display: flex;
  justify-content: center;
  padding-top: 70px;
}

.titleBar {
  width: 100%;
  height: 110px;
  background: #be8737;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.titleName {
  height: 64px;
  width: 484px;
  background-image: url("../assets/logo.png");
  background-size: cover;
  margin-left: 80px;
}

.titlePhone {
  color: #fefefd;
  letter-spacing: 2px;
  margin-right: 80px;
}

.joinUs {
  width: 181px;
  height: 52px;
  background-image: url("../assets/join.png");
  background-size: cover;
  margin-top: 50px;
  cursor: pointer;
}

.userName {
  display: flex;
  align-items: center;
  color: #fff;
  margin-right: 80px;
}

.entryLink {
  width: 139px;
  height: 55px;
  background-image: url("../assets/lo2.png");
  background-size: cover;
  margin-right: 80px;
}

.entryLink:hover {
  background-image: url("../assets/lo.png");
}
</style>
